module.exports = __webpack_public_path__ + "static/media/gtwalsheimpro-regular-webfont.a6f64159.woff";